module.exports = __webpack_public_path__ + "img/bg.3f7a628.png";